// Keep in sync with app/lib/constants/attribute_constants.py:
// BRAND_NAME, MANUFACTURER_NAME, FEATURES_AND_BENEFITS_EXTENDED,
// PRIVATE_BRAND_PRODUCT_MANUFACTURER_ID.

const GlobalAttributes = {
  gtin: 'gtin',
  status: 'status',
  brand_name: 'brand_name',
  manufacturer_name: 'manufacturer_name',
  features_and_benefits_extended: 'features_and_benefits_extended',
  /** GlobalManufacturer.id per vendor product */
  private_brand_product_manufacturer_id: 'private_brand_product_manufacturer_id',
};

export default GlobalAttributes;
